import Flag from 'LuxKit/Flag'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import setLanguageCookie from 'cookies/setLanguageCookie'
import { LANGUAGE_OPTIONS } from 'constants/languages'
import { useAppSelector } from 'hooks/reduxHooks'
import { useCallback } from 'react'
import * as React from 'react'

interface Props {
  onLanguageSelect?: React.MouseEventHandler<HTMLButtonElement>
}

function NavBarLanguageItems(props: Props) {
  const { onLanguageSelect } = props
  const locale = useAppSelector(state => state.geo.locale)

  const currentLanguage = LANGUAGE_OPTIONS.find(lang => lang.locale === locale) ?? LANGUAGE_OPTIONS[0]

  const onLanguageClick = useCallback<React.MouseEventHandler<HTMLButtonElement>>((e) => {
    const langCode = e.currentTarget.dataset.langcode
    if (langCode && langCode !== currentLanguage.langCode) {
      setLanguageCookie(langCode)
      const url = new URL(window.location.href)
      url.searchParams.delete('lang')
      window.location.href = url.pathname + url.search
    }
    onLanguageSelect?.(e)
  }, [onLanguageSelect, currentLanguage.langCode])

  return <>
    {LANGUAGE_OPTIONS.map(language => <ClickableListItem
      size="medium"
      key={language.langCode}
      startIcon={<Flag countryCode={language.flagCode} />}
      endIcon={currentLanguage.langCode === language.langCode ? <LineCheckIcon /> : undefined}
      title={language.nativeName}
      data-langcode={language.langCode}
      onClick={onLanguageClick}
      selected={currentLanguage.langCode === language.langCode}
    />)}
  </>
}

export default React.memo(NavBarLanguageItems)
